import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { base64 } from '@firebase/util';
import { CentralizedAPI, AuthService, SystemDateResponseDTO, SystemDate } from "@easyfo/common-lib";

@Injectable({
    providedIn: 'root',
})
export class CentralizedService {
    constructor(
        private centralizedAPI: CentralizedAPI,
        private cookieService: CookieService,
        private authService: AuthService
    ) { }

    requestSystemDate(hotelId: string, callback: any) {
        let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
        this.centralizedAPI.requestSystemDate(jwt, hotelId).subscribe(
            (response: SystemDateResponseDTO) => {
                if (response.success == true) {
                    let date: SystemDate = response.data;
                    let expired = base64.decodeString(this.cookieService.get("expired"), false);
                    let expiredDate = new Date(expired);
                    this.cookieService.set("sdate", base64.encodeString(date.system_date), { expires: expiredDate, path: '/', domain: location.hostname });
                    callback();
                }
            },
            (error) => {
                if (this.authService.handleSessionExpired(error) == true) {
                    return;
                }
                callback();
            }
        );
    }

}
